import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { useRequestHandler } from '@/hooks/useRequestHandler'

import ConfigureCpsCardStep, { ConfigureCpsCardStepValues } from '@/pages/getting-started/components/ConfigureCpsCardStep'

import { selectAuthUserUpdateRequestState, updateMyProfile } from '@/redux/reducers/auth.reducer'

export function ConfigureCpsCardStepContainer(props: { onComplete?: () => void }) {
  const { onComplete } = props
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const { dispatch, requestTracker: authUserUpdateRequestTracker } = useRequestHandler({
    onSuccess: () => {
      onComplete?.()
    },
    onError: () => {
      enqueueSnackbar(t('notification.authUser.update.error'), { variant: 'error' })
    },
    requestTrackerSelector: selectAuthUserUpdateRequestState
  })

  return (
    <ConfigureCpsCardStep
      confirmText={t('common:button.done.label')}
      isSubmitting={authUserUpdateRequestTracker.loading}
      onSubmit={(values: ConfigureCpsCardStepValues) => {
        dispatch(updateMyProfile({ cps: values.cps }))
      }}
    />
  )
}

export default ConfigureCpsCardStepContainer